import React from 'react';
import { Switch, Route, Link, useHistory } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContextProvider';
import { useModuleContext } from '../../context/ModuleProvider';
import { ProfileImg } from '../helper';

function NavHeader({ title, mainroute }) {
  let history = useHistory();
  return (
    <div className="main-header navbar navbar-expand bg-white navbar-light border-bottom d-flex justify-content-between align-items-center">
      <table>
        <tbody>
          <tr>
            <td className="d1">
              {mainroute ? (
                <Link to="#" className="nav-link d-lg-none" data-widget="pushmenu">
                  <i style={{ marginLeft: '-20px', marginRight: '25px' }} className="flaticon-sidebar"></i>
                </Link>
              ) : (
                <div onClick={() => history.goBack()} className="nav-link">
                  <i style={{ marginLeft: '-8px' }} className="fa fa-chevron-left"></i>
                </div>
              )}
            </td>
            <td className="d2">
              <strong style={{ marginLeft: '-15px' }}>{title || 'smart'}</strong>
            </td>
            <td className="d3">
              <Switch>
                <Route path="/:moduleId/dashboard/calendar">
                  <UserProfile />
                </Route>
                <Route path="/:moduleId/dashboard/:type">
                  <FilterButton />
                </Route>
                <Route path="*">
                  <UserProfile />
                </Route>
              </Switch>
            </td>
          </tr>
        </tbody>
      </table>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://betaparadise.avyaas.app"
        style={{
          background: 'rgba(33, 111, 255, 0.05)',
          border: '2px solid #A5C8FF',
          borderRadius: '999px',
          padding: '4px 10px',
          display: 'flex',
          alignItems: 'center',
          fontWeight: 500,
          fontSize: '14px',
          color: '#216FFF',
          gap: '6px',
          cursor: 'pointer',
          boxShadow: 'none',
          marginRight: '10px',
        }}
      >
        {/* Notification Bell SVG */}
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 16V11C18 7.68629 15.3137 5 12 5C8.68629 5 6 7.68629 6 11V16L4 18V19H20V18L18 16Z"
            stroke="#216FFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 21C9.55228 21.618 10.3261 22 11.1667 22H12.8333C13.6739 22 14.4477 21.618 15 21"
            stroke="#216FFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span style={{ color: '#216FFF' }}>New Version Available for Testing</span>
      </a>
    </div>
  );
}

function FilterButton() {
  return (
    <Link
      to="#"
      className="btn-link btn-success btn-sm py-1 px-3 mt-1"
      data-toggle="modal"
      data-target="#exampleModal"
      style={{ fontSize: '20px', boxShadow: 'none' }}
    >
      <i className="ion-ios-settings" />
    </Link>
  );
}

function UserProfile() {
  let { currentUser } = useAuthContext();
  let { moduleId } = useModuleContext();
  let { imageId } = currentUser;

  return (
    <Link to={`/${moduleId}/profile`}>
      <ProfileImg
        src={imageId}
        alt="User Profile "
        className="brand-image img-circle elevation-3 div-only-mobile bg-cover"
        style={{
          marginTop: '0px',
          height: '35px',
          width: '35px',
        }}
      />
    </Link>
  );
}

export default NavHeader;
